import { render, staticRenderFns } from "./CreateUpdateUserInterface.vue?vue&type=template&id=859f74ae&scoped=true&"
import script from "./CreateUpdateUserInterface.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateUserInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859f74ae",
  null
  
)

export default component.exports